import { AppConfigService } from '../app-config.service/app-config.service';
import { Injectable } from '@angular/core';
import { LoginService } from '../login-service/login.service';
import { IObject } from '../../models/interfaces/IObject';
import { FEATURE_FLAGS } from '../../constants/global.constant';
import { HttpClient } from '@angular/common/http';
import { endPoints } from '../../constants/endpoints';
import { SessionStorageUtility } from '../../utils/sessionStorageUtils';

declare let window: any;
@Injectable({
  providedIn: 'root',
})
export class ChatWidgetService {
  constructor(
    private appConfigService: AppConfigService,
    private loginService: LoginService,
    private readonly http: HttpClient,
  ) {}

  loadChatWidget(): void {
    const isChatWidgetVisible =
      (
        this.loginService.userProfile?.accountDetails?.[0]?.features ?? []
      ).findIndex((feat) => feat.code === FEATURE_FLAGS.messagingInWeb) !== -1;
    if (isChatWidgetVisible) {
      const config = this.appConfigService.appConfig;
      const script = document.createElement('script');
      script.src = config.chatWidgetConfig?.scriptUrl;
      script.id = 'chatWidget';
      script.async = true;
      script.defer = true;
      script.onload = () => this.initEmbeddedMessaging(config);
      document.body.appendChild(script);
    }
  }

  initEmbeddedMessaging(config: IObject) {
    try {
      if (!window.embeddedservice_bootstrap) return;
      window.embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'
      window.addEventListener('onEmbeddedMessagingReady', () => {
        const chatSession = SessionStorageUtility.get('chatSession');
        if (chatSession?.id) {
          window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            PortalSession: chatSession.id,
          });
        } else {
          this.http
            .post(endPoints.casemgmt.createChatSession.URI, null)
            .subscribe((res: any) => {
              SessionStorageUtility.set('chatSession', {
                id: res.id,
              });
              window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
                {
                  PortalSession: res.id,
                },
              );
            });
        }
      });

      window.embeddedservice_bootstrap.init(
        config.chatWidgetConfig.channelId,
        config.chatWidgetConfig.channelName,
        config.chatWidgetConfig.channelUrl,
        {
          scrt2URL: config.chatWidgetConfig.scrt2URL,
        },
      );
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err);
    }
  }
}
